export const TELEGRAM_USER_LINK = "https://t.me/";
